export default {
  bioLabel: 'Bio',
  levelLabel: 'Nivel',
  subjectsLabel: 'Materias que imparte',
  phoneLabel: 'Teléfono'
}

export const en = {
  bioLabel: 'Bio',
  levelLabel: 'Level',
  subjectsLabel: 'Subjects taught',
  phoneLabel: 'Telephone'
}

export const ca = {
  bioLabel: 'Bio',
  levelLabel: 'Nivell',
  subjectsLabel: 'Assignatures que imparteix',
  phoneLabel: 'Telèfon'
}
